import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import GameLogic from "@bd-core/game-logic";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import { createInfoTooltipLayer } from "@bd-utils/info-tooltip";

/** Max photo file size in bytes (10MB), must match backend SUBMISSION_PHOTO_MAX_BYTES. */
const PHOTO_MAX_BYTES = 10 * 1024 * 1024;
/** Max video file size in bytes (50MB), must match backend SUBMISSION_VIDEO_MAX_BYTES. */
const VIDEO_MAX_BYTES = 50 * 1024 * 1024;
/** "Over time" days field: minimum (inclusive). */
const CRITERIA_DAYS_MIN = 1;
/** "Over time" days field: maximum (inclusive). */
const CRITERIA_DAYS_MAX = 8;

export class ChallengePage extends BD_Component {
    constructor() {
        super();

        this.id = "challenge-page";
        this.template = "challenge-page-template";

        this.elms = {
            challengePage: ".challenge-page",
            app: ".app",
            backToHomeButton: ".challenge-page__header__back",
            challengePageTitle: ".challenge-page__header__title",
            challengePageSubtitle: ".challenge-page__header__subtitle",
            countdownTime: ".challenge-page__countdown__time",
            challengeList: ".challenge-page__list",
            openChallengeButton: ".challenge-page__item__button",
            challengeItem: ".challenge-page__item",
            surpriseChallengeItem: "li.surprise-challenge",
            modal: ".challenge-page__modal.specific-challenge",
            modalBackButton: ".modal__header__back",
            modalHeaderTitle: ".modal__header__title",
            modalHeaderTimeCountdown: ".modal__header__time__countdown",
            challengeSectionHeading: ".section__heading",
            modalBlocksRoot: ".js-challenge-modal-blocks",
            modalBodySection: ".modal__body__section",
            sectionCriteria: ".modal__body__section.criteria",
            sectionTitle: ".section__title",
            sectionContentImage: ".section__content__image",
            sectionContentText: ".section__content__text",
            sectionContentDescription: ".section__content__description",
            sectionContentVideo: ".section__content__video",
            sectionContentVideoEl: ".section__content__video video",
            sectionContentQuestion: ".section__content__question",
            sectionContentCriteria: ".section__content__criteria",
            challengeBuildWrapper: ".challenge__build",
            challengeBuildReset: ".challenge__build__reset",
            challengeBuildTheme: ".challenge__build__theme",
            // challengeBuildSubtheme: ".challenge__build__subtheme",
            challengeBuildDifficulty: ".challenge__build__difficulty",
            challengeBuildOption: ".js-select-build-option",
            challengeBuildCampaignOption: ".js-select-campaign",
            challengeBuildFinish: ".js-finish-build",
            criteriaInput:
                ".specific-challenge .section__content__criteria input[type='text']",
            criteriaInputText: "input[type='text']",
            criteriaInputAmount: "input[data-input='amount']",
            criteriaInputDays: "input[data-input='days']",
            questionCounter: ".specific-challenge .question-counter",
            questionItem: ".specific-challenge .question-item",
            questionTitle: ".specific-challenge .question-title",
            questionAnswers: ".specific-challenge .question-answers",
            questionAnswer: ".specific-challenge .question-answer",
            questionSubmit: ".specific-challenge .question-submit",
            sectionContentReward: ".section__content__reward span",
            sectionContentComplete: ".section__content__complete",
            sectionContentAbandon: ".section__content__abandon",
            sectionContentRewardValue: ".section__content__reward__value",
            modalExtraSubmission: ".modal__extra__submission",
            submissionTitle: ".submission__title",
            submissionSectionTextarea:
                ".modal__extra .submission__section textarea",
            submissionPoints: ".submission__points span",
            submissionUpload: ".submission__upload",
            submissionUploadInput: "#submission-upload-input",
            submissionCurrentUpload: "#submission-current-upload",
            submissionPreviewBg: ".submission__preview__bg",
            submissionPreviewContent: ".submission__preview__content",
            submissionRetake: ".submission__retake",
            submissionSubmit: ".submission__submit",
            submissionConsentCheck:
                ".submission__consent__check input[type='checkbox']",
            startChallengeButton: ".section__content__start",
            outcomeModal: ".challenge-page__modal.challenge-outcome",
            outcomeModalClose: ".challenge-outcome .modal__close",
            outcomeModalStatusAction: ".modal__status__action",
            outcomeModalStatusAvatar: ".modal__status__avatar",
            outcomeModalTitle: ".modal__title",
            outcomeModalPointsValue: ".modal__points__value span",
            outcomeModalImage: ".modal__image img",
            abandonChallengeModal: ".challenge-page__modal.abandon-challenge",
            abandonChallengeModalCancelButton:
                ".challenge-page__modal.abandon-challenge .modal__actions__cancel",
            abandonChallengeModalConfirmButton:
                ".challenge-page__modal.abandon-challenge .modal__actions__confirm",
            shuffleButton: ".challenge-page__shuffle",
            shufflePopupModal: ".challenge-page__modal.shuffle-popup",
            shufflePopupCancelButton:
                ".challenge-page__modal.shuffle-popup .modal__actions__cancel",
            shufflePopupConfirmButton:
                ".challenge-page__modal.shuffle-popup .modal__actions__confirm",
            uploadConfirmationModal:
                ".challenge-page__modal.upload-confirmation",
            uploadConfirmationClose:
                ".challenge-page__modal.upload-confirmation .modal__close",
            startFormingSentenceButton: ".challenge-page__empty__button",
            formSentenceModal:
                ".challenge-page__modal.select-starting-challenge",
            backToMainChallenge:
                ".challenge-page__modal.select-starting-challenge .modal__header__back",
            challengeBuildOptions: ".challenge__build__options",
        };

        this.classes = {
            modalOpen: "modal--is-open",
            isActiveChallenge: "is-active-challenge",
            expanded: "expanded",
            isVideo: "is-video",
            isMultipleChoice: "is-multiple-choice",
            isStaticAmount: "is-static-amount",
            isStatic: "is-static",
            isStaticDays: "is-static-days",
            hasStarted: "has-started",
            isText: "is-text",
            isPhoto: "is-photo",
            surpriseChallenge: "surprise-challenge",
            isSubmitting: "is-submitting",
            isPreviewAvailable: "is-preview-available",
            isActive: "is-active",
            criteriaLabel: "criteria-label",
            questionItem: "question-item",
            questionTitle: "question-title",
            questionAnswers: "question-answers",
            questionAnswer: "question-answer",
            isSelected: "is-selected",
            questionItemHidden: "is-hidden",
            itemImage: "challenge-page__item__image",
            itemSection: "challenge-page__item__section",
            itemHeading: "challenge-page__item__heading",
            itemTag: "challenge-page__item__tag",
            itemTitle: "challenge-page__item__title",
            itemInfo: "challenge-page__item__info",
            itemLabels: "challenge-page__item__labels",
            itemLabel: "challenge-page__item__label",
            itemLabelIcon: "challenge-page__item__label__icon",
            itemBumper: "challenge-page__item__bumper",
            itemReward: "challenge-page__item__reward",
            itemPointsIcon: "challenge-page__item__points-icon",
            itemButton: "challenge-page__item__button",
            item: "challenge-page__item",
            hasCompleted: "has-completed",
            isCompleted: "is-completed",
            hasNoActiveChallenge: "has-no-active-challenge",
            isCampaign: "is-campaign",
            selectTheme: "select-theme",
            // selectSubtheme: "select-subtheme",
            selectDifficulty: "select-difficulty",
            isReady: "is-ready",
        };

        this._events = this.getEvents();
        this._countdownInterval = null;
        this._infoTooltip = null;
        this._teamId = null;
        this._challengeIds = [];
        this._challenges = [];
        this._unfinishedAbandonedChallenge = null;
        this._openedChallenge = null;
        this._openedFromSurprise = false;
        /** @type {Record<number, { questions: object[], currentQuestionIndex: number, selections: Record<number, number[]> }>} */
        this._quizByBlock = {};
        this._criteriaSizingBindings = [];
        this._themes = [];
        this._subthemes = [];
        this._difficulties = [];
        this._sentenceSteps = ["themes", "difficulties"];
        this._currentStep = 0;
        this._selectedBuild = {
            theme: null,
            // subtheme: null,
            difficulty: null,
        };
    }

    /**
     * localStorage key for quiz progress per challenge (cleared on submit success / abandon).
     * @param {string|number} teamId
     * @param {string|number} challengeId
     * @returns {string}
     */
    getQuizStorageKey(teamId, challengeId) {
        return `bd_quiz_${teamId}_${challengeId}`;
    }

    /**
     * @param {object} challenge
     * @returns {object[]}
     */
    getChallengeBlocks(challenge) {
        if (!challenge) return [];
        if (Array.isArray(challenge.blocks) && challenge.blocks.length > 0) {
            return challenge.blocks;
        }
        if (challenge.block_1) {
            return [challenge.block_1];
        }
        return [];
    }

    /**
     * @param {object} challenge
     * @returns {boolean}
     */
    challengeHasQuestionQuiz(challenge) {
        const blocks = this.getChallengeBlocks(challenge);
        return blocks.some(
            (b) =>
                b?.type === "question" &&
                Array.isArray(b?.questions) &&
                b.questions.length > 0,
        );
    }

    /**
     * Legacy storage was a flat map of questionIndex -> selected[] for a single question block.
     * New storage is blockIndex -> { questionIndex -> selected[] }.
     *
     * @param {object} parsed
     * @param {object} challenge
     * @returns {object}
     */
    normalizeQuizStorageObject(parsed, challenge) {
        if (!parsed || typeof parsed !== "object") {
            return {};
        }
        const blocks = this.getChallengeBlocks(challenge);
        const questionBlockIndices = blocks
            .map((b, i) =>
                b?.type === "question" && b?.questions?.length ? i : -1,
            )
            .filter((i) => i >= 0);
        if (questionBlockIndices.length !== 1) {
            return parsed;
        }
        const vals = Object.values(parsed);
        const keys = Object.keys(parsed);
        const looksLikeLegacyFlat =
            keys.length > 0 &&
            keys.every((k) => /^\d+$/.test(k)) &&
            vals.every((v) => Array.isArray(v));
        if (looksLikeLegacyFlat) {
            return { [String(questionBlockIndices[0])]: parsed };
        }
        return parsed;
    }

    /**
     * @param {number} blockIndex
     */
    getQuizBlockSection(blockIndex) {
        return $(this.elms.modal).find(
            `.modal__body__section[data-block-index="${blockIndex}"]`,
        );
    }

    persistQuizSelectionsToStorage() {
        if (!this._teamId || !this._openedChallenge?.id) return;
        const key = this.getQuizStorageKey(
            this._teamId,
            this._openedChallenge.id,
        );
        const out = {};
        Object.keys(this._quizByBlock).forEach((bi) => {
            const state = this._quizByBlock[bi];
            if (state?.selections && Object.keys(state.selections).length > 0) {
                out[bi] = state.selections;
            }
        });
        try {
            localStorage.setItem(key, JSON.stringify(out));
        } catch {
            // ignore
        }
    }

    /**
     * True when every question-type block has all nested questions answered.
     * @returns {boolean}
     */
    areAllQuizQuestionsAnswered() {
        const challenge = this._openedChallenge;
        if (!challenge) return false;
        const blocks = this.getChallengeBlocks(challenge);
        for (let i = 0; i < blocks.length; i++) {
            const block = blocks[i];
            if (
                block?.type !== "question" ||
                !Array.isArray(block?.questions) ||
                block.questions.length === 0
            ) {
                continue;
            }
            const state = this._quizByBlock[i];
            if (!state?.questions?.length) return false;
            for (let q = 0; q < state.questions.length; q++) {
                const sel = state.selections[q];
                if (!Array.isArray(sel) || sel.length === 0) return false;
            }
        }
        return true;
    }

    /**
     * Build quiz payload for submit-challenge: { block, q, selected }[].
     * @returns {Array<{ block: number, q: number, selected: number[] }>|null}
     */
    getQuizAnswersPayload() {
        if (!this._teamId || !this._openedChallenge?.id) return null;
        const challenge = this._openedChallenge;
        const key = this.getQuizStorageKey(this._teamId, challenge.id);

        const fromMem = {};
        Object.keys(this._quizByBlock).forEach((bi) => {
            const state = this._quizByBlock[bi];
            if (state?.selections && Object.keys(state.selections).length > 0) {
                fromMem[bi] = { ...state.selections };
            }
        });

        let fromStore = {};
        try {
            const stored = localStorage.getItem(key);
            if (stored) {
                fromStore = this.normalizeQuizStorageObject(
                    JSON.parse(stored),
                    challenge,
                );
            }
        } catch {
            // ignore
        }

        const merged = {};
        const blockKeysRaw = [
            ...Object.keys(fromMem),
            ...Object.keys(fromStore),
        ];
        const blockKeys = blockKeysRaw.filter(
            (k, i) => blockKeysRaw.indexOf(k) === i,
        );
        blockKeys.forEach((bk) => {
            const mem = fromMem[bk] || {};
            const st = fromStore[bk] || {};
            merged[bk] = { ...st, ...mem };
        });

        const out = [];
        Object.keys(merged).forEach((blockStr) => {
            const block = parseInt(blockStr, 10);
            const selByQ = merged[blockStr];
            if (!selByQ || typeof selByQ !== "object") return;
            Object.keys(selByQ).forEach((qStr) => {
                const selected = selByQ[qStr];
                out.push({
                    block,
                    q: parseInt(qStr, 10),
                    selected: Array.isArray(selected) ? [...selected] : [],
                });
            });
        });
        out.sort((a, b) =>
            a.block !== b.block ? a.block - b.block : a.q - b.q,
        );
        return out.length ? out : null;
    }

    getEvents() {
        const elms = this.elms;

        return [
            {
                selector: elms.backToHomeButton,
                event: "click",
                handler: this.handleBackToHome,
            },
            {
                selector: elms.challengeItem,
                event: "click",
                handler: this.handleSurpriseMe,
            },
            {
                selector: elms.challengeItem,
                event: "click",
                handler: this.handleOpenChallenge,
            },
            {
                selector: elms.modalBackButton,
                event: "click",
                handler: this.handleBackToMain,
            },
            {
                selector: elms.challengeSectionHeading,
                event: "click",
                handler: this.handleClickSectionHeading,
            },
            {
                selector: elms.startChallengeButton,
                event: "click",
                handler: this.handleStartChallenge,
            },
            {
                selector: elms.criteriaInput,
                event: "input",
                handler: this.handleCriteriaInputChange,
            },
            {
                selector: elms.challengeBuildOption,
                event: "click",
                handler: this.handleSelectBuildOptionClick,
            },
            {
                selector: elms.challengeBuildReset,
                event: "click",
                handler: this.handleSelectBuildReset,
            },
            {
                selector: elms.outcomeModalClose,
                event: "click",
                handler: this.handleOutcomeModalClose,
            },
            {
                selector: elms.sectionContentComplete,
                event: "click",
                handler: this.handleCompleteChallenge,
            },
            {
                selector: elms.submissionUpload,
                event: "click",
                handler: this.handleSubmissionUploadClick,
            },
            {
                event: "change",
                selector: elms.submissionUploadInput,
                handler: this.handleSubmissionUploadChange,
            },
            {
                selector: elms.submissionRetake,
                event: "click",
                handler: this.handleSubmissionRetakeClick,
            },
            {
                selector: elms.submissionSubmit,
                event: "click",
                handler: this.handleSubmissionSubmitClick,
            },
            {
                selector: elms.submissionConsentCheck,
                event: "change",
                handler: this.handleSubmissionConsentCheckChange,
            },
            {
                selector: `${elms.modal} .${this.classes.questionAnswer}`,
                event: "click",
                handler: this.handleQuestionAnswerClick,
            },
            {
                selector: elms.submissionSectionTextarea,
                event: "input",
                handler: this.handleSubmissionTextareaInput,
            },
            {
                selector: elms.sectionContentAbandon,
                event: "click",
                handler: this.toggleAbandonChallengeModal,
            },
            {
                selector: elms.abandonChallengeModalCancelButton,
                event: "click",
                handler: this.toggleAbandonChallengeModal,
            },
            {
                selector: elms.abandonChallengeModalConfirmButton,
                event: "click",
                handler: this.handleAbandonChallengeConfirmClick,
            },
            {
                selector: elms.shuffleButton,
                event: "click",
                handler: this.toggleShufflePopup,
            },
            {
                selector: elms.uploadConfirmationClose,
                event: "click",
                handler: this.handleUploadConfirmationClose,
            },
            {
                selector: elms.shufflePopupCancelButton,
                event: "click",
                handler: this.handleShufflePopupCancelClick,
            },
            {
                selector: elms.shufflePopupConfirmButton,
                event: "click",
                handler: this.handleShufflePopupConfirmClick,
            },
            {
                selector: elms.questionSubmit,
                event: "click",
                handler: this.handleQuestionSubmitClick,
            },
            {
                selector: elms.startFormingSentenceButton,
                event: "click",
                handler: this.handleStartFormingSentenceClick,
            },
            {
                selector: elms.backToMainChallenge,
                event: "click",
                handler: this.handleBackToMainChallengeClick,
            },
            {
                selector: elms.challengeBuildFinish,
                event: "click",
                handler: this.handleFinishChallengeBuild,
            },
            {
                selector: elms.challengeBuildCampaignOption,
                event: "click",
                handler: this.handleSelectCampaignClick,
            },
        ];
    }

    beforeInit() {
        this._teamId = localStorage.getItem("teamId");
        this.render();
        this.setGameState();
    }

    async render() {
        this._teardownInfoTooltip();
        const data = this._data;
        this._themes = data.challenge_page.challenge_selection.themes;
        // this._subthemes = data.challenge_page.challenge_selection.subthemes;
        this._subthemes = [];
        this._difficulties =
            data.challenge_page.challenge_selection.difficulties;

        // await this.shuffleChallenges();
        await this.getActiveChallenge();

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(this.elms.app).html(html);

        this._infoTooltip = createInfoTooltipLayer(
            "challenge",
            $(this.elms.app),
        );
        this._infoTooltip.setTriggerText(
            $(this.elms.app).find(".challenge-page__header__info"),
            CONFIG.game?.tooltip?.challenge_page ?? "",
        );
        this._infoTooltip.setTriggerText(
            $(this.elms.app).find(`${this.elms.modal} .modal__header__info`),
            CONFIG.game?.tooltip?.challenge_page_detail ?? "",
        );

        this.populateChallengeDetail();

        // this.checkUnfinishedAbandonedChallenge();

        // this.populateChallenges();
        // this.startCountdown();
        this.setupCriteriaInputSizing();
    }

    setGameState() {}

    _teardownInfoTooltip() {
        this._infoTooltip?.destroy();
        this._infoTooltip = null;
    }

    beforeDestroy() {
        this._teardownInfoTooltip();
        if (this._countdownInterval) {
            clearInterval(this._countdownInterval);
            this._countdownInterval = null;
        }
        this._teardownCriteriaInputSizing();
    }

    _teardownCriteriaInputSizing() {
        this._criteriaSizingBindings.forEach((binding) => {
            if (binding.$input && binding.updateWidth) {
                binding.$input.off("input.criteriaSizing", binding.updateWidth);
            }
            if (binding.mirror && binding.mirror.parentNode) {
                binding.mirror.remove();
            }
        });
        this._criteriaSizingBindings = [];
    }

    // dynamic criteria input width size
    setupCriteriaInputSizing() {
        const $inputs = $(this.elms.criteriaInput);
        if (!$inputs.length) return;

        $inputs.each((_, inputElm) => {
            if (!(inputElm instanceof HTMLInputElement)) return;

            const input = inputElm;
            const $input = $(input);
            const mirror = document.createElement("span");
            const style = window.getComputedStyle(input);
            [
                "fontFamily",
                "fontSize",
                "fontWeight",
                "letterSpacing",
                "textTransform",
                "lineHeight",
            ].forEach((prop) => {
                mirror.style[prop] = style[prop];
            });
            mirror.style.position = "absolute";
            mirror.style.visibility = "hidden";
            mirror.style.whiteSpace = "pre";
            mirror.style.padding = "0 16px";
            mirror.setAttribute("aria-hidden", "true");
            document.body.appendChild(mirror);

            const updateWidth = () => {
                mirror.textContent = input.value || input.placeholder || "";
                const w = mirror.offsetWidth;
                input.style.width = w ? `${w}px` : "";
            };

            this._criteriaSizingBindings.push({
                mirror,
                $input,
                updateWidth,
            });

            updateWidth();
            $input.on("input.criteriaSizing", updateWidth);
        });
    }

    handleBackToHome(e) {
        e.preventDefault();
        const $page = $(this.elms.challengePage);
        if ($page.hasClass(this.classes.hasNoActiveChallenge)) {
            GameLogic.goToPage("home-page");
            return;
        }
        this.resetFormSentenceBuildStateImmediate();
        $(this.elms.formSentenceModal).addClass(this.classes.modalOpen);
        this._scheduleRestartSelectThemeIntroAnimations();
    }

    _resetFormSentenceSelectionState() {
        this._currentStep = 0;
        this._selectedBuild = {
            theme: null,
            // subtheme: null,
            difficulty: null,
        };
        $(this.elms.challengePage).removeClass(this.classes.isCampaign);
    }

    _finishFormSentenceBuildDomReset() {
        const $wrapper = $(this.elms.challengeBuildWrapper);
        $(".challenge__build__option").removeClass("is-selected is-disabled");
        $wrapper.removeClass(
            "animation-finished select-theme select-subtheme select-difficulty is-ready",
        );
        $wrapper.addClass("select-theme");
        $wrapper.find("b").text("");
    }

    /** Full reset of theme / subtheme / difficulty flow (no reset-button animation). */
    resetFormSentenceBuildStateImmediate() {
        this._resetFormSentenceSelectionState();
        this._finishFormSentenceBuildDomReset();
        this.populateBuildOptions();
    }

    /**
     * Theme line + campaign block are static in the template; option buttons are recreated
     * by populateBuildOptions(), so their CSS animations restart. Force the same for
     * persistent nodes (e.g. after opening the modal from is-campaign).
     */
    _restartSelectThemeIntroAnimations() {
        const $wrapper = $(this.elms.challengeBuildWrapper);
        if (!$wrapper.hasClass(this.classes.selectTheme)) {
            return;
        }

        const restart = (el) => {
            if (!(el instanceof HTMLElement)) {
                return;
            }
            el.style.animation = "none";
            void el.offsetWidth;
            el.style.animation = "";
        };

        const $theme = $wrapper.find(this.elms.challengeBuildTheme);
        if ($theme.length) {
            restart($theme.get(0));
        }

        const $campaign = $wrapper.find(".challenge__build__campaign-option");
        if ($campaign.length) {
            restart($campaign.get(0));
        }
    }

    /** Run after the forming-sentence modal is shown so intro animations paint correctly. */
    _scheduleRestartSelectThemeIntroAnimations() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this._restartSelectThemeIntroAnimations();
            });
        });
    }

    /**
     * Called when the countdown reaches 0 (midnight Dutch time).
     */
    async onCountdownReached() {
        await this.shuffleChallenges();
        this.populateChallenges();
        // Set countdown to next midnight so startCountdown() doesn't immediately fire again (loop).
        const $el = $(this.elms.countdownTime);
        const lastMidnight = parseInt($el.data("midnight-utc"), 10);
        if ($el.length && Number.isFinite(lastMidnight)) {
            $el.data("midnight-utc", lastMidnight + 86400); // next day (24h in seconds)
        }
        this.startCountdown();
    }

    startCountdown() {
        const $el = $(this.elms.countdownTime);
        const $modalCountdown = $(this.elms.modalHeaderTimeCountdown);
        if (!$el.length) return;

        const midnightUtc = parseInt($el.data("midnight-utc"), 10);
        if (!Number.isFinite(midnightUtc)) return;

        const update = () => {
            const now = Math.floor(Date.now() / 1000);
            let remaining = midnightUtc - now;

            if (remaining <= 0) {
                if (this._countdownInterval) {
                    clearInterval(this._countdownInterval);
                    this._countdownInterval = null;
                }
                $el.text("0h 0m 0s");
                this.onCountdownReached();
                return;
            }

            const h = Math.floor(remaining / 3600);
            const m = Math.floor((remaining % 3600) / 60);
            const s = remaining % 60;
            $el.text(`${h}h ${m}m ${s}s`);
            $modalCountdown.text(`${h}h ${m}m ${s}s`);
        };

        update();
        this._countdownInterval = setInterval(update, 1000);
    }

    async shuffleChallenges() {
        const [res] = await bdjs.goAsync(
            bdapi.post("game/shuffle-challenges", { teamId: this._teamId }),
        );

        this._challenges = res?.data?.data.challenges ?? [];
        this._unfinishedAbandonedChallenge =
            res?.data?.data.unfinished_abandoned_challenge ?? null;
        this._challengeIds = this._challenges.map((challenge) => challenge.id);
    }

    populateChallenges() {
        const challenges = this._challenges;
        const themeURL = CONFIG.themeURL || "";
        const $list = $(this.elms.challengeList);
        $list.empty();

        for (let i = challenges.length - 1; i >= 0; i--) {
            const challenge = challenges[i];
            const title = challenge.title || "";
            const challengeType = challenge.completion.type || "";
            const challengeTypeLabel = this._data.challenge_page.challenge_selection.challenge_type_labels[challengeType];
            const challengeTypeIcon =
                challengeType === "text"
                    ? "align-left"
                    : challengeType === "photo"
                      ? "image"
                      : "video-small";
            const challengeTiming = challenge.completion.timing;
            const imageUrl =
                challenge.image || `${themeURL}/assets/images/daily-banner.png`;
            const points = challenge.points != null ? challenge.points : 20;
            const c = this.classes;
            const isActive = challenge.is_active ? ` ${c.isActive}` : "";
            const isCompleted = challenge.is_completed
                ? ` ${c.isCompleted}`
                : "";
            const tagLabel = challenge.is_completed
                ? "Completed Challenge"
                : "Active Challenge";
            const challengeTimingValue = challenge.completion?.timing?.value;
            const challengeTimingLabel = this._data.challenge_page.challenge_selection.timing_labels[challengeTimingValue];
            const itemHtml = `
                <li class="${c.item}${isActive}${isCompleted}" data-challenge-id="${challenge.id || ""}">
                    <img class="${c.itemImage}" src="${imageUrl}" alt="${title.replace(/"/g, "&quot;")}" />
                    <div class="${c.itemSection}">
                        <div class="${c.itemHeading}">
                            <div class="${c.itemTag}">
                                <span>${tagLabel}</span>
                            </div>
                            <h3 class="${c.itemTitle}">${title.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</h3>
                        </div>
                        <div class="${c.itemInfo}">
                            <div class="${c.itemLabels}">
                                ${
                                    challengeTiming
                                        ? `
                                    <div class="${c.itemLabel}">
                                        <div class="${c.itemLabelIcon}">
                                            <img src="${themeURL}/assets/images/timer-small.svg" alt="" />
                                        </div>
                                        <span>${challengeTimingLabel}</span>
                                    </div>
                                `
                                        : ""
                                }
                                <div class="${c.itemLabel}">
                                    <div class="${c.itemLabelIcon}">
                                        <img src="${themeURL}/assets/images/${challengeTypeIcon}.svg" alt="" />
                                    </div>
                                    <span>${challengeTypeLabel}</span>
                                </div>
                            </div>
                            <div class="${c.itemBumper}">
                                <div class="${c.itemReward}">
                                    <span>${this._data.challenge_page.challenge_selection.reward_text_label}</span>
                                    <img src="${themeURL}/assets/images/points.svg" alt="" class="${c.itemPointsIcon}" />
                                    <span>${points}</span>
                                </div>
                                <button class="${c.itemButton}" type="button">
                                    <img src="${themeURL}/assets/images/arrow-up-right.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
            `;
            $list.prepend(itemHtml);
        }

        const activeChallenge = this._challenges.find((c) => c.is_active);
        if (activeChallenge) {
            this._openedChallenge = activeChallenge;
            this.populateChallengeDetail();
        }
    }

    /**
     * @param {object} $section
     * @param {object} block
     * @param {number} blockIndex
     * @param {object} challenge
     */
    applyBlockToSection($section, block, blockIndex, challenge) {
        $section.attr("data-block-index", String(blockIndex));
        $section
            .find(this.elms.sectionTitle)
            .text(block?.title || "Challenge Information");

        const $desc = $section.find(this.elms.sectionContentDescription);
        const $image = $section.find(this.elms.sectionContentImage);
        const $videoWrap = $section.find(this.elms.sectionContentVideo);
        const $questionWrap = $section.find(this.elms.sectionContentQuestion);

        $section.removeClass(
            `${this.classes.isVideo} ${this.classes.isMultipleChoice}`,
        );

        if (block?.type === "text") {
            $videoWrap.hide();
            $questionWrap.hide();
            if (block?.image) {
                $image.attr("src", block.image);
                $image.attr(
                    "alt",
                    block?.title || challenge.title || "information",
                );
                $image.show();
            } else {
                $image.attr("src", "").hide();
            }
            if (block?.content) {
                $desc.html(block.content).show();
            } else {
                $desc.empty().hide();
            }
            return;
        }

        if (block?.type === "video") {
            $image.attr("src", "").hide();
            $questionWrap.hide();
            if (block?.content) {
                $desc.html(block.content).show();
            } else {
                $desc.empty().hide();
            }
            const videoSrc = block?.video || "";
            $section
                .find(this.elms.sectionContentVideoEl)
                .attr("src", videoSrc);
            $videoWrap.toggle(!!videoSrc);
            if (videoSrc) $section.addClass(this.classes.isVideo);
            return;
        }

        if (block?.type === "question") {
            $image.attr("src", "").hide();
            $desc.empty().hide();
            $videoWrap.hide();
            const hasQuestions =
                block?.questions &&
                Array.isArray(block.questions) &&
                block.questions.length > 0;
            if (hasQuestions) {
                $questionWrap.css("display", "flex");
                $section.addClass(this.classes.isMultipleChoice);
            } else {
                $questionWrap.hide();
            }
            return;
        }

        $videoWrap.hide();
        $questionWrap.hide();
        $image.attr("src", "").hide();
        $desc.empty().hide();
    }

    /**
     * @param {object} $criteriaSection
     * @param {object} actionBlock
     * @param {number} points
     */
    applyActionBlockToCriteriaSection($criteriaSection, actionBlock, points) {
        $criteriaSection
            .find(this.elms.sectionTitle)
            .text(actionBlock?.title || "Challenge Criteria");

        const content = actionBlock?.content || "";
        const parts = content.split(/(\{amount\}|\{days\})/g);
        const isOverTime =
            this._openedChallenge?.completion?.timing?.value === "over_time";
        const isUnfinishedAbandoned =
            !!this._openedChallenge?.is_unfinished_abandoned;
        const isStatic = actionBlock?.input_amount_type === "static";
        const amountVal =
            actionBlock?.amount != null ? String(actionBlock.amount) : "";
        const isStaticEmptyAmount = isStatic && amountVal.trim() === "";
        const daysVal =
            this._openedChallenge?.days != null
                ? String(this._openedChallenge.days)
                : "";
        const hasAmountToken = content.indexOf("{amount}") !== -1;
        const hasStarted = !!this._openedChallenge?.is_active;
        const daysReadonlyAttr = hasStarted ? " readonly" : "";

        $criteriaSection.removeClass(
            `${this.classes.isStatic} ${this.classes.isStaticAmount} ${this.classes.isStaticDays}`,
        );
        if (isUnfinishedAbandoned) {
            $criteriaSection.addClass(this.classes.isStatic);
            if (hasAmountToken) {
                $criteriaSection.addClass(this.classes.isStaticAmount);
            }
        } else {
            $criteriaSection.toggleClass(
                this.classes.isStaticAmount,
                !!isStatic,
            );
        }

        const escapeHtml = (text) =>
            String(text || "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");

        const criteriaParts = [];
        parts.forEach((part) => {
            if (part === "{amount}") {
                if (isUnfinishedAbandoned) {
                    const rawAm =
                        this._openedChallenge?.amount != null
                            ? String(this._openedChallenge.amount)
                            : "";
                    const valueAttr = ` value="${escapeHtml(rawAm).replace(/"/g, "&quot;")}" readonly`;
                    criteriaParts.push(
                        `<input type="text" inputmode="numeric" placeholder="${this._data.challenge_page.challenge_detail.amount_text_label}" data-input="amount"${valueAttr} />`,
                    );
                    return;
                }
                if (isStaticEmptyAmount) return;
                const valueAttr =
                    isStatic && amountVal
                        ? ` value="${escapeHtml(amountVal).replace(/"/g, "&quot;")}" readonly`
                        : "";
                criteriaParts.push(
                    `<input type="text" inputmode="numeric" placeholder="${this._data.challenge_page.challenge_detail.amount_text_label}" data-input="amount"${valueAttr} />`,
                );
                return;
            }

            if (part === "{days}") {
                if (!isOverTime) return;
                if (isUnfinishedAbandoned) {
                    const d = this._openedChallenge?.days;
                    const daysStr =
                        d != null && d !== "" && !Number.isNaN(Number(d))
                            ? String(d)
                            : "1";
                    const valueAttr = ` value="${escapeHtml(daysStr).replace(/"/g, "&quot;")}"`;
                    criteriaParts.push(
                        `<input type="text" inputmode="numeric" placeholder="${this._data.challenge_page.challenge_detail.days_text_label}" data-input="days"${valueAttr}${daysReadonlyAttr} />`,
                    );
                    return;
                }
                const valueAttr = daysVal
                    ? ` value="${escapeHtml(daysVal).replace(/"/g, "&quot;")}"`
                    : "";
                criteriaParts.push(
                    `<input type="text" inputmode="numeric" placeholder="${this._data.challenge_page.challenge_detail.days_text_label}" data-input="days"${valueAttr}${daysReadonlyAttr} />`,
                );
                return;
            }

            if (!part) return;
            criteriaParts.push(
                `<span class="${this.classes.criteriaLabel}">${escapeHtml(part)}</span>`,
            );
        });
        const criteriaHtml = criteriaParts.join("");
        $criteriaSection
            .find(this.elms.sectionContentCriteria)
            .html(criteriaHtml);
        $criteriaSection.find(this.elms.sectionContentRewardValue).text(points);
    }

    populateChallengeDetail() {
        const challenge = this._openedChallenge;
        if (!challenge) return;

        const $modal = $(this.elms.modal);
        const blocks = this.getChallengeBlocks(challenge);
        const actionBlock = challenge.action_block || challenge.block_2 || {};
        const completion = challenge.completion;
        const points = challenge.points != null ? challenge.points : 20;
        const isUnfinishedAbandoned = !!challenge.is_unfinished_abandoned;

        this._quizByBlock = {};

        $modal.find(this.elms.modalHeaderTitle).text(challenge.title || "");
        $modal.find(this.elms.modalHeaderTimeCountdown).text("—");
        const backLabel = challenge.is_active
            ? this._data?.challenge_page?.challenge_selection
                  ?.secondary_button_label
            : this._data?.challenge_page?.challenge_detail
                  ?.secondary_button_label;
        $modal
            .find(this.elms.modalBackButton)
            .find("span")
            .text(backLabel ?? "");

        const $root = $modal.find(this.elms.modalBlocksRoot);
        $root.empty();

        const contentTpl = document.getElementById(
            "challenge-content-section-template",
        );
        const criteriaTpl = document.getElementById(
            "challenge-criteria-section-template",
        );

        blocks.forEach((block, blockIndex) => {
            if (!(contentTpl instanceof HTMLTemplateElement)) return;
            const node = document.importNode(contentTpl.content, true);
            $root[0].appendChild(node);
            const $section = $root.children(".modal__body__section").last();
            this.applyBlockToSection($section, block, blockIndex, challenge);
        });

        let $criteriaSection = $();
        if (criteriaTpl instanceof HTMLTemplateElement) {
            const cNode = document.importNode(criteriaTpl.content, true);
            $root[0].appendChild(cNode);
            $criteriaSection = $root.children(".criteria").last();
            this.applyActionBlockToCriteriaSection(
                $criteriaSection,
                actionBlock,
                points,
            );
        }

        let storedRaw = {};
        try {
            const raw = localStorage.getItem(
                this.getQuizStorageKey(this._teamId, challenge.id),
            );
            if (raw) {
                storedRaw = this.normalizeQuizStorageObject(
                    JSON.parse(raw),
                    challenge,
                );
            }
        } catch {
            storedRaw = {};
        }

        blocks.forEach((block, blockIndex) => {
            if (
                block?.type !== "question" ||
                !block?.questions ||
                !Array.isArray(block.questions) ||
                block.questions.length === 0
            ) {
                return;
            }
            this._quizByBlock[blockIndex] = {
                questions: block.questions,
                currentQuestionIndex: 0,
                selections: {},
            };
            const sub = storedRaw[String(blockIndex)];
            if (sub && typeof sub === "object" && !Array.isArray(sub)) {
                Object.keys(sub).forEach((qk) => {
                    const qkNum = parseInt(qk, 10);
                    const v = sub[qk];
                    this._quizByBlock[blockIndex].selections[qkNum] =
                        Array.isArray(v) ? [...v] : [];
                });
            }
            const st = this._quizByBlock[blockIndex];
            const qs = st.questions;
            let allAnswered = true;
            for (let qi = 0; qi < qs.length; qi++) {
                const sel = st.selections[qi];
                if (!Array.isArray(sel) || sel.length === 0) {
                    allAnswered = false;
                    break;
                }
            }
            if (allAnswered) {
                st.currentQuestionIndex = qs.length - 1;
            }
            this.renderCurrentMultipleChoiceQuestion(blockIndex);
            const $qWrap = this.getQuizBlockSection(blockIndex).find(
                this.elms.sectionContentQuestion,
            );
            if (allAnswered) {
                $qWrap.addClass("is-all-answered");
            } else {
                $qWrap.removeClass("is-all-answered");
            }
        });

        const $submission = $modal.find(this.elms.modalExtraSubmission);
        $submission.removeClass(
            `${this.classes.isText} ${this.classes.isPhoto} ${this.classes.isVideo}`,
        );
        const compType = completion?.type || "text";
        const compTypeClass =
            compType === "text"
                ? this.classes.isText
                : compType === "photo"
                  ? this.classes.isPhoto
                  : this.classes.isVideo;
        $submission.addClass(compTypeClass).attr("data-type", compType);
        if (compType === "text") {
            $modal.find(this.elms.submissionSectionTextarea).val("");
            this.updateSubmissionSubmitState();
        }
        $submission
            .find(this.elms.submissionUploadInput)
            .attr(
                "accept",
                compType === "photo"
                    ? "image/*"
                    : compType === "video"
                      ? "video/*"
                      : "image/*,video/*",
            );
        $modal
            .find(this.elms.submissionTitle)
            .text(
                completion?.title ||
                    "What have you learned while doing this challenge?",
            );
        $modal
            .find(this.elms.submissionSectionTextarea)
            .attr(
                "placeholder",
                completion?.input_field_placeholder ||
                    "Write your answer here...",
            );
        $modal.find(this.elms.submissionPoints).last().text(points);

        if (challenge.is_active) {
            $root
                .find(this.elms.modalBodySection)
                .removeClass(this.classes.expanded);
            if ($criteriaSection.length) {
                $criteriaSection.addClass(
                    `${this.classes.expanded} ${this.classes.hasStarted}`,
                );
                $criteriaSection
                    .find(this.elms.criteriaInputAmount)
                    .val(challenge.amount);
                const $daysIn = $criteriaSection.find(
                    this.elms.criteriaInputDays,
                );
                if ($daysIn.length) {
                    $daysIn
                        .attr("readonly", "readonly")
                        .val(
                            challenge.days != null
                                ? String(challenge.days)
                                : $daysIn.val(),
                        );
                }
            }
        } else {
            $root
                .find(this.elms.modalBodySection)
                .removeClass(this.classes.expanded);
            const $first = $root.find(this.elms.modalBodySection).first();
            if ($first.length) {
                $first.addClass(this.classes.expanded);
            }
        }

        $modal
            .addClass(this.classes.modalOpen)
            .addClass(
                challenge.is_active ? this.classes.isActiveChallenge : "",
            );
        if (isUnfinishedAbandoned) {
            $modal.addClass(
                `${this.classes.isActiveChallenge} ${this.classes.isSubmitting}`,
            );
            $(this.elms.submissionPoints).text(
                this._data.challenge_page.challenge_detail
                    .completing_abandon_reward,
            );
        }

        this._teardownCriteriaInputSizing();
        this.setupCriteriaInputSizing();
        this.updateStartButtonState();
    }

    /**
     * @param {number} blockIndex
     */
    renderCurrentMultipleChoiceQuestion(blockIndex) {
        const state = this._quizByBlock[blockIndex];
        const questions = state?.questions;
        const idx = state?.currentQuestionIndex;
        if (
            !questions?.length ||
            idx == null ||
            idx < 0 ||
            idx >= questions.length
        ) {
            return;
        }

        const $section = this.getQuizBlockSection(blockIndex);
        if (!$section.length) return;

        const $counter = $section.find(".question-counter");
        const $item = $section.find(".question-item");
        const $title = $section.find(".question-title");
        const $answersList = $section.find(".question-answers");
        const $submitBtn = $section.find(".question-submit");

        if (
            !$counter.length ||
            !$item.length ||
            !$title.length ||
            !$answersList.length ||
            !$submitBtn.length
        ) {
            return;
        }

        const q = questions[idx];
        const total = questions.length;
        const current = idx + 1;

        $counter.find("span").html(`<b>${current}</b>/${total}`);
        $title.text(q.question || "");

        const answers = q.answers || [];
        const indexToLetter = (i) => {
            let n = i + 1;
            let s = "";
            while (n > 0) {
                const r = (n - 1) % 26;
                s = String.fromCharCode(65 + r) + s;
                n = Math.floor((n - 1) / 26);
            }
            return s;
        };
        $answersList.empty();
        answers.forEach((a, i) => {
            const letter = indexToLetter(i);
            const isCorrect = !!a.is_correct;
            const $li = $(
                `<li class="${this.classes.questionAnswer}" tabindex="0" role="button" data-correct="${isCorrect ? "true" : "false"}">` +
                    `<div class="question-answer-wrapper">` +
                    `<div class="question-answer-icon">${letter}</div>` +
                    `<span>${(a.answer || "").replace(/</g, "&lt;").replace(/>/g, "&gt;")}</span>` +
                    `</div>` +
                    `</li>`,
            )
                .attr("data-question-index", idx)
                .attr("data-answer-index", i)
                .data("correct", isCorrect);
            $answersList.append($li);
        });
        const selections = state.selections;
        const selectedIndices = Array.isArray(selections[idx])
            ? selections[idx]
            : [];
        selectedIndices.forEach((aIdx) => {
            $answersList
                .find(
                    `.${this.classes.questionAnswer}[data-answer-index="${aIdx}"]`,
                )
                .addClass(this.classes.isSelected);
        });
        this.updateMultipleChoiceSubmitState(blockIndex);

        $item.removeClass(this.classes.questionItemHidden);
    }

    /**
     * @param {number} blockIndex
     */
    updateMultipleChoiceSubmitState(blockIndex) {
        const state = this._quizByBlock[blockIndex];
        if (!state?.questions?.length) return;
        const $section = this.getQuizBlockSection(blockIndex);
        if (!$section.length) return;
        const $answers = $section.find(".question-answer");
        const $submitBtn = $section.find(".question-submit");
        const hasSelection = $answers.filter(".is-selected").length > 0;
        if (hasSelection) {
            $submitBtn.removeAttr("disabled");
        } else {
            $submitBtn.attr("disabled", "disabled");
        }
    }

    handleQuestionAnswerClick(e) {
        e.preventDefault();
        const challenge = this._openedChallenge;
        if (!challenge) return;
        const $answer = $(e.currentTarget);
        if (!$answer.hasClass(this.classes.questionAnswer)) return;
        const $section = $answer.closest("[data-block-index]");
        if (!$section.length) return;
        const blockIndex = parseInt($section.attr("data-block-index"), 10);
        if (Number.isNaN(blockIndex)) return;
        const state = this._quizByBlock[blockIndex];
        if (!state?.questions?.length) return;

        const qIdx = parseInt(
            $answer.attr("data-question-index") ??
                $answer.data("question-index"),
            10,
        );
        const aIdx = parseInt(
            $answer.attr("data-answer-index") ?? $answer.data("answer-index"),
            10,
        );
        if (isNaN(qIdx) || isNaN(aIdx)) return;
        const q = state.questions[qIdx];
        if (!q?.answers?.length) return;
        if (!Array.isArray(state.selections[qIdx])) {
            state.selections[qIdx] = [];
        }
        const selected = state.selections[qIdx];
        const idx = selected.indexOf(aIdx);
        if (idx >= 0) {
            selected.splice(idx, 1);
            $answer.removeClass(this.classes.isSelected);
        } else {
            const $answersList = $section.find(".question-answers");
            $answersList
                .find(
                    `.${this.classes.questionAnswer}[data-question-index="${qIdx}"]`,
                )
                .removeClass(this.classes.isSelected);
            state.selections[qIdx] = [aIdx];
            $answer.addClass(this.classes.isSelected);
        }
        if (this._teamId && challenge.id) {
            this.persistQuizSelectionsToStorage();
        }
        this.updateMultipleChoiceSubmitState(blockIndex);
    }

    handleQuestionSubmitClick(e) {
        e.preventDefault();
        const $section = $(e.currentTarget).closest("[data-block-index]");
        if (!$section.length) return;
        const blockIndex = parseInt($section.attr("data-block-index"), 10);
        if (Number.isNaN(blockIndex)) return;
        const state = this._quizByBlock[blockIndex];
        const questions = state?.questions;
        const idx = state?.currentQuestionIndex;
        if (
            !questions?.length ||
            idx == null ||
            idx < 0 ||
            idx >= questions.length
        ) {
            return;
        }

        const $answers = $section.find(".question-answer");
        $answers.each((i, answer) => {
            const $answer = $(answer);
            if ($answer.hasClass("is-selected")) {
                const isCorrect = $answer.data("correct") === true;
                if (isCorrect) {
                    $answer.addClass("is-correct");
                } else {
                    $answer.addClass("is-incorrect");
                }
            }
        });

        setTimeout(() => {
            const $item = $section.find(".question-item");
            const $submitBtn = $section.find(".question-submit");
            const isLastQuestion = idx + 1 >= questions.length;
            $item.addClass("is-hidden");
            $submitBtn.hide();
            $item.one("transitionend", () => {
                state.currentQuestionIndex = idx + 1;
                this.renderCurrentMultipleChoiceQuestion(blockIndex);
                $item.removeClass("is-hidden");
                if (!isLastQuestion) {
                    $submitBtn.show();
                }
                {
                    this.updateStartButtonState();
                }
            });
        }, 1500);
    }

    async handleSurpriseMe(e) {
        e.preventDefault();
        // If not a surprise challenge, skip
        const $li = $(e.currentTarget).closest(this.elms.challengeItem);
        if (!$li.hasClass(this.classes.surpriseChallenge)) return;
        const challengeIds = this._challengeIds;

        const [res] = await bdjs.goAsync(
            bdapi.post("game/surprise-challenge", {
                excluded_challenge_ids: challengeIds,
                team_id: this._teamId,
            }),
        );

        if (res?.data?.success !== true || !res?.data?.data) return;

        const challenge = res.data.data;
        if (!challenge || challenge.id == null) return;

        this._openedChallenge = { ...challenge };
        this._openedFromSurprise = true;
        this.populateChallengeDetail();
    }

    handleOpenChallenge(e) {
        e.preventDefault();
        // If a surprise challenge, skip
        const $li = $(e.currentTarget).closest(this.elms.challengeItem);
        if ($li.hasClass(this.classes.surpriseChallenge)) return;

        const openedChallengeId = $(e.currentTarget)
            .closest(this.elms.challengeItem)
            .data("challenge-id");
        this._openedChallenge = this._challenges.find(
            (challenge) => challenge.id === openedChallengeId,
        );
        this._openedFromSurprise = false;

        this.populateChallengeDetail();
    }

    handleBackToMain(e) {
        e.preventDefault();
        const $modal = $(this.elms.modal);

        if (
            this._openedChallenge?.is_active ||
            this._unfinishedAbandonedChallenge
        ) {
            GameLogic.goToPage("home-page");
            return;
        }

        this._openedChallenge = null;
        if (this._openedFromSurprise) {
            this._openedFromSurprise = false;
        }

        $modal.removeClass(
            `${this.classes.modalOpen} ${this.classes.isActiveChallenge} ${this.classes.isSubmitting}`,
        );
        $modal
            .find(`${this.elms.modalBlocksRoot} ${this.elms.modalBodySection}`)
            .removeClass(this.classes.expanded);
        const $firstBody = $modal
            .find(`${this.elms.modalBlocksRoot} ${this.elms.modalBodySection}`)
            .first();
        if ($firstBody.length) {
            $firstBody.addClass(this.classes.expanded);
            $firstBody.removeClass(
                `${this.classes.isVideo} ${this.classes.isMultipleChoice}`,
            );
        }
        $modal
            .find(this.elms.sectionCriteria)
            .removeClass(
                `${this.classes.hasStarted} ${this.classes.isStaticAmount} ${this.classes.isStatic} ${this.classes.isStaticDays}`,
            );
        $modal
            .find(this.elms.modalExtraSubmission)
            .removeClass(
                `${this.classes.isText} ${this.classes.isPhoto} ${this.classes.isVideo}`,
            );
    }

    handleClickSectionHeading(e) {
        e.preventDefault();
        const $section = $(e.currentTarget).closest(this.elms.modalBodySection);

        if ($section.hasClass(this.classes.expanded)) return;

        $(this.elms.modalBodySection).removeClass(this.classes.expanded);
        $section.addClass(this.classes.expanded);
    }

    isCriteriaValid($modal) {
        const $criteriaInput = $modal.find(
            `${this.elms.sectionContentCriteria} ${this.elms.criteriaInputText}`,
        );
        if ($criteriaInput.length === 0) return true;
        let isValid = true;

        $criteriaInput.each((_, input) => {
            const $in = $(input);
            const val = String($in.val() ?? "").trim();
            if ($in.is(this.elms.criteriaInputDays)) {
                const numericVal = Number(val);
                if (
                    !val ||
                    Number.isNaN(numericVal) ||
                    !Number.isInteger(numericVal) ||
                    numericVal < CRITERIA_DAYS_MIN ||
                    numericVal > CRITERIA_DAYS_MAX
                ) {
                    isValid = false;
                    return false;
                }
                return true;
            }
            if (
                this._openedChallenge?.is_unfinished_abandoned &&
                $in.is(this.elms.criteriaInputAmount)
            ) {
                const n = Number(val);
                if (val === "" || Number.isNaN(n) || n < 0) {
                    isValid = false;
                    return false;
                }
                return true;
            }
            const numericVal = Number(val);
            if (!val || Number.isNaN(numericVal) || numericVal < 1) {
                isValid = false;
                return false;
            }
            return true;
        });

        return isValid;
    }

    updateStartButtonState() {
        const $modal = $(this.elms.modal);
        const $btn = $modal.find(this.elms.startChallengeButton);
        if (!$btn.length) return;
        const isValidCriteria = this.isCriteriaValid($modal);
        const isQuestionBlocksMandatory =
            this._openedChallenge?.completion?.timing?.value === "immediately"
                ? this.areAllQuizQuestionsAnswered()
                : true;

        if (isValidCriteria && isQuestionBlocksMandatory) {
            $btn.removeAttr("disabled");
        } else {
            $btn.attr("disabled", "disabled");
        }
    }

    handleCriteriaInputChange(e) {
        const input = e?.currentTarget;
        if (
            input instanceof HTMLInputElement &&
            $(input).is(this.elms.criteriaInputDays)
        ) {
            const val = String(input.value ?? "").trim();
            if (val !== "") {
                const numericVal = Number(val);
                if (
                    !Number.isNaN(numericVal) &&
                    numericVal > CRITERIA_DAYS_MAX
                ) {
                    alert(
                        `You can choose a maximum of ${CRITERIA_DAYS_MAX} days. Please enter a number from ${CRITERIA_DAYS_MIN} to ${CRITERIA_DAYS_MAX}.`,
                    );
                    input.value = String(CRITERIA_DAYS_MAX);
                    $(input).trigger("input");
                    return;
                }
            }
        }
        this.updateStartButtonState();
    }

    async handleStartChallenge(e) {
        e.preventDefault();
        const $modal = $(this.elms.modal);
        if (!this.isCriteriaValid($modal)) {
            $modal
                .find(this.elms.startChallengeButton)
                .attr("disabled", "disabled");
            return;
        }

        const actionBlock =
            this._openedChallenge?.action_block ||
            this._openedChallenge?.block_2;
        const isStatic = actionBlock?.input_amount_type === "static";
        const amountConfig =
            actionBlock?.amount != null ? String(actionBlock.amount) : "";
        const isStaticEmptyAmount = isStatic && amountConfig.trim() === "";
        const $amountInput = $modal.find(this.elms.criteriaInputAmount);
        const amount = isStaticEmptyAmount
            ? 0
            : $amountInput.length
              ? $amountInput.val()
              : 0;

        const timingValue = this._openedChallenge?.completion?.timing?.value;
        const startPayload = {
            challenge_id: this._openedChallenge.id,
            amount: amount,
            team_id: this._teamId,
            is_surprise: this._openedFromSurprise ? 1 : 0,
        };
        if (timingValue === "over_time") {
            const $daysInput = $modal.find(this.elms.criteriaInputDays);
            if ($daysInput.length) {
                const raw = String($daysInput.val() ?? "").trim();
                const n = parseInt(raw, 10);
                if (
                    !Number.isNaN(n) &&
                    Number.isInteger(n) &&
                    n >= CRITERIA_DAYS_MIN &&
                    n <= CRITERIA_DAYS_MAX
                ) {
                    startPayload.days = n;
                }
            }
        }

        const [res] = await bdjs.goAsync(
            bdapi.post("game/start-challenge", startPayload),
        );

        if (res?.data?.success === true) {
            const data = res.data.data;
            if (Array.isArray(data) ? data.length > 0 : !!data) {
                if (
                    this._openedChallenge?.completion?.timing?.value ===
                    "immediately"
                ) {
                    $(this.elms.modal).addClass(
                        `${this.classes.isActiveChallenge} ${this.classes.isSubmitting}`,
                    );
                    this._challenges.find(
                        (c) => c.id === this._openedChallenge.id,
                    ).is_active = true;
                    this.handleCompleteChallenge();
                } else {
                    this._openedFromSurprise = false;
                    this.populateOutcomeModal(data);
                }
            }
        } else if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
        }
    }

    populateOutcomeModal(data) {
        const themeURL = CONFIG.themeURL || "";
        const $outcome = $(this.elms.outcomeModal);

        if (data.is_completed) {
            $(this.elms.outcomeModal).addClass(this.classes.hasCompleted);
        }

        const avatarSrc = data.avatar || `${themeURL}/assets/images/player.png`;
        const imageSrc =
            (data.image && typeof data.image === "object" && data.image.url) ||
            (typeof data.image === "string" ? data.image : null) ||
            `${themeURL}/assets/images/daily-banner.png`;
        $outcome
            .find(this.elms.outcomeModalStatusAvatar)
            .attr("src", avatarSrc);
        $outcome
            .find(this.elms.outcomeModalStatusAction)
            .html(data.outcome_title || "");
        $outcome.find(this.elms.outcomeModalTitle).text(data.title || "");
        $outcome
            .find(this.elms.outcomeModalPointsValue)
            .text(`+${data.points ?? 0}`);
        $outcome.find(this.elms.outcomeModalImage).attr("src", imageSrc);

        $(this.elms.modal).removeClass(this.classes.modalOpen);
        $outcome.addClass(this.classes.modalOpen);
    }

    handleSelectBuildOptionClick(e) {
        e.preventDefault();

        const optionText = $(e.currentTarget).text();
        const termId = $(e.currentTarget).data("term-id");

        $(".challenge__build__option")
            .not(e.currentTarget)
            .addClass("is-disabled");
        $(e.currentTarget).addClass("is-selected");

        const $wrapper = $(this.elms.challengeBuildWrapper);
        if ($wrapper.hasClass("select-theme")) {
            this._currentStep = 1;
            $(this.elms.challengeBuildTheme).find("b").text(optionText);
            this._selectedBuild.theme = termId;

            setTimeout(() => {
                $wrapper.addClass("animation-finished");

                setTimeout(() => {
                    $(".challenge__build__option").removeClass(
                        "is-selected is-disabled",
                    );
                    $wrapper
                        .removeClass("animation-finished select-theme")
                        .addClass("select-difficulty");

                    this.populateBuildOptions();
                }, 500);
            }, 500);
        // } else if ($wrapper.hasClass("select-subtheme")) {
        //     this._currentStep = 2;
        //     $(this.elms.challengeBuildSubtheme).find("b").text(optionText);
        //     this._selectedBuild.subtheme = termId;
        //
        //     setTimeout(() => {
        //         $wrapper.addClass("animation-finished");
        //
        //         setTimeout(() => {
        //             $(".challenge__build__option").removeClass(
        //                 "is-selected is-disabled",
        //             );
        //             $wrapper
        //                 .removeClass("animation-finished select-subtheme")
        //                 .addClass("select-difficulty");
        //
        //             this.populateBuildOptions();
        //         }, 500);
        //     }, 500);
        } else if ($wrapper.hasClass("select-difficulty")) {
            $(this.elms.challengeBuildDifficulty).find("b").text(optionText);
            this._selectedBuild.difficulty = termId;

            setTimeout(() => {
                $wrapper.addClass("animation-finished");

                setTimeout(() => {
                    $(".challenge__build__option").removeClass(
                        "is-selected is-disabled",
                    );
                    $wrapper
                        .removeClass("animation-finished select-difficulty")
                        .addClass("is-ready");

                    this.populateBuildOptions();
                }, 500);
            }, 500);
        }
    }

    handleSelectBuildReset(e) {
        e.preventDefault();

        const $wrapper = $(this.elms.challengeBuildWrapper);

        this._resetFormSentenceSelectionState();
        this.populateBuildOptions();

        $wrapper.addClass("animation-finished");

        setTimeout(() => {
            this._finishFormSentenceBuildDomReset();
        }, 250);
    }

    handleOutcomeModalClose(e) {
        e.preventDefault();
        $(this.elms.outcomeModal).removeClass(this.classes.modalOpen);
        GameLogic.goToPage("home-page");
    }

    handleUploadConfirmationClose(e) {
        e.preventDefault();
        $(this.elms.uploadConfirmationModal).removeClass(
            this.classes.modalOpen,
        );
    }

    handleCompleteChallenge(e) {
        if (e) {
            e.preventDefault();
        }
        $(this.elms.modal).addClass(this.classes.isSubmitting);
    }

    handleSubmissionUploadClick(e) {
        e.preventDefault();
        $(this.elms.submissionUploadInput).click();
    }

    handleSubmissionUploadChange(e) {
        e.preventDefault();
        const elms = this.elms;
        const file = $(elms.submissionUploadInput).prop("files")[0];
        if (!file) return;

        const extraSubmission = $(this.elms.modal).find(
            this.elms.modalExtraSubmission,
        );
        const type = extraSubmission.attr("data-type");

        const maxBytes = type === "video" ? VIDEO_MAX_BYTES : PHOTO_MAX_BYTES;
        if (file.size > maxBytes) {
            const limitMsg =
                type === "video"
                    ? "Video must be 50MB or smaller."
                    : "Photo must be 10MB or smaller.";
            alert(limitMsg);
            $(elms.submissionUploadInput).val("");
            return;
        }

        extraSubmission
            .addClass(this.classes.isPreviewAvailable)
            .attr("data-type", type);

        if (type === "photo") {
            $(elms.submissionPreviewBg)
                .empty()
                .append(
                    $("<img />", {
                        src: URL.createObjectURL(file),
                        alt: "Submission upload",
                    }),
                );
            $(elms.submissionPreviewContent)
                .empty()
                .append(
                    $("<img />", {
                        src: URL.createObjectURL(file),
                        alt: "Submission upload",
                    }),
                );
        } else if (type === "video") {
            $(elms.submissionPreviewBg).empty();
            $(elms.submissionPreviewContent)
                .empty()
                .append(
                    $("<video />", {
                        src: URL.createObjectURL(file),
                        controls: true,
                        alt: "Submission upload",
                    }),
                );
        }
        this.updateSubmissionSubmitState();
    }

    handleSubmissionRetakeClick(e) {
        e.preventDefault();
        $(this.elms.submissionUploadInput).val("");
        $(this.elms.submissionCurrentUpload).val("");
        $(this.elms.submissionPreviewBg).empty();
        $(this.elms.submissionPreviewContent).empty();
        $(this.elms.modal)
            .find(this.elms.modalExtraSubmission)
            .removeClass(this.classes.isPreviewAvailable);
        this.updateSubmissionSubmitState();
    }

    async handleSubmissionSubmitClick(e) {
        e.preventDefault();
        const elms = this.elms;
        const compType =
            $(this.elms.modal)
                .find(this.elms.modalExtraSubmission)
                .attr("data-type") || "text";
        const apiCompType = compType === "photo" ? "photo" : compType;

        if (compType === "text") {
            const textValue = $(this.elms.modal)
                .find(this.elms.submissionSectionTextarea)
                .val();
            const payload = {
                compType: apiCompType,
                submissionContent:
                    typeof textValue === "string" ? textValue.trim() : "",
                teamId: this._teamId,
            };
            const quizPayload = this.getQuizAnswersPayload();
            if (
                this.challengeHasQuestionQuiz(this._openedChallenge) &&
                Array.isArray(quizPayload) &&
                quizPayload.length > 0
            ) {
                payload.quizAnswers = quizPayload;
            }
            const [res] = await bdjs.goAsync(
                bdapi.post("game/submit-challenge", payload),
            );

            if (res?.data?.success === true) {
                const data = res.data.data;
                if (Array.isArray(data) ? data.length > 0 : !!data) {
                    this.populateOutcomeModal(data);
                    this._openedChallenge = null;
                }
                if (
                    this._openedChallenge?.id &&
                    this._teamId &&
                    this.challengeHasQuestionQuiz(this._openedChallenge)
                ) {
                    try {
                        localStorage.removeItem(
                            this.getQuizStorageKey(
                                this._teamId,
                                this._openedChallenge.id,
                            ),
                        );
                    } catch {
                        // ignore
                    }
                }
            } else {
                $(this.elms.modal).removeClass(this.classes.isSubmitting);
                if (res?.data?.data?.message) {
                    alert(res.data.data.message);
                }
            }
            return;
        }

        const file = $(elms.submissionUploadInput).prop("files")[0];
        if (!file) {
            return;
        }
        const formData = new FormData();
        formData.append("compType", apiCompType);
        formData.append("submissionContent", file);
        formData.append("teamId", this._teamId);
        const quizPayload = this.getQuizAnswersPayload();
        if (
            this.challengeHasQuestionQuiz(this._openedChallenge) &&
            Array.isArray(quizPayload) &&
            quizPayload.length > 0
        ) {
            formData.append("quizAnswers", JSON.stringify(quizPayload));
        }
        const [res] = await bdjs.goAsync(
            bdapi.post("game/submit-challenge", formData),
        );

        if (res?.data?.success === true) {
            const data = res.data.data;
            if (Array.isArray(data) ? data.length > 0 : !!data) {
                this.populateOutcomeModal(data);
                this._openedChallenge = null;
            }
            if (
                this._openedChallenge?.id &&
                this._teamId &&
                this.challengeHasQuestionQuiz(this._openedChallenge)
            ) {
                try {
                    localStorage.removeItem(
                        this.getQuizStorageKey(
                            this._teamId,
                            this._openedChallenge.id,
                        ),
                    );
                } catch {
                    // ignore
                }
            }
        } else {
            $(this.elms.modal).removeClass(this.classes.isSubmitting);
            if (res?.data?.data?.message) {
                alert(res.data.data.message);
            }
        }
    }

    handleSubmissionTextareaInput() {
        const $extra = $(this.elms.modal).find(this.elms.modalExtraSubmission);
        if ($extra.attr("data-type") === "text") {
            this.updateSubmissionSubmitState();
        }
    }

    /**
     * Updates submit button disabled state. For text submission: enabled only when
     * textarea has length > 0. For photo/video: enabled when upload is present and consent is checked.
     */
    updateSubmissionSubmitState() {
        const elms = this.elms;
        const $modal = $(this.elms.modal);
        const $extra = $modal.find(elms.modalExtraSubmission);
        const type = $extra.attr("data-type") || "text";
        const consentChecked = $modal
            .find(elms.submissionConsentCheck)
            .is(":checked");
        const $submit = $modal.find(elms.submissionSubmit);

        if (type === "text") {
            const textLength = String(
                $modal.find(elms.submissionSectionTextarea).val() ?? "",
            ).trim().length;
            if (textLength > 0) {
                $submit.removeAttr("disabled");
            } else {
                $submit.attr("disabled", "disabled");
            }
        } else {
            const hasUpload = $extra.hasClass(this.classes.isPreviewAvailable);
            if (consentChecked && hasUpload) {
                $submit.removeAttr("disabled");
            } else {
                $submit.attr("disabled", "disabled");
            }
        }
    }

    handleSubmissionConsentCheckChange(e) {
        e.preventDefault();
        const isChecked = $(e.currentTarget).prop("checked");
        if (isChecked) {
            $(this.elms.uploadConfirmationModal).addClass(
                this.classes.modalOpen,
            );
        }
        this.updateSubmissionSubmitState();
    }

    toggleAbandonChallengeModal(e) {
        e.preventDefault();
        $(this.elms.abandonChallengeModal).toggleClass(this.classes.modalOpen);
    }

    async handleAbandonChallengeConfirmClick(e) {
        e.preventDefault();
        $(this.elms.abandonChallengeModal).removeClass(this.classes.modalOpen);
        const [res] = await bdjs.goAsync(
            bdapi.post("game/abandon-challenge", {
                teamId: this._teamId,
            }),
        );

        if (res?.data?.success === true) {
            const data = res.data.data;
            if (Array.isArray(data) ? data.length > 0 : !!data) {
                this.populateOutcomeModal(data);
                this._openedChallenge = null;
            }
            const activeChallenge = this._challenges.find((c) => c.is_active);
            if (
                activeChallenge?.id &&
                this._teamId &&
                this.challengeHasQuestionQuiz(activeChallenge)
            ) {
                try {
                    localStorage.removeItem(
                        this.getQuizStorageKey(
                            this._teamId,
                            activeChallenge.id,
                        ),
                    );
                } catch {
                    // ignore
                }
            }
            await this.shuffleChallenges();
            this.populateChallenges();
        } else if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
        }
        return;
    }

    async forceShuffleChallenges() {
        const [res] = await bdjs.goAsync(
            bdapi.post("game/force-shuffle-challenges", {
                teamId: this._teamId,
            }),
        );

        if (res?.data?.success === true) {
            this._challenges = res?.data?.data.challenges ?? [];
            this._unfinishedAbandonedChallenge =
                res?.data?.data.unfinished_abandoned_challenge ?? null;
        } else if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
        }
        this._challengeIds = this._challenges.map((challenge) => challenge.id);
    }

    toggleShufflePopup(e) {
        e.preventDefault();
        $(this.elms.shufflePopupModal).toggleClass(this.classes.modalOpen);
    }

    handleShufflePopupCancelClick(e) {
        e.preventDefault();
        $(this.elms.shufflePopupModal).removeClass(this.classes.modalOpen);
    }

    async handleShufflePopupConfirmClick(e) {
        e.preventDefault();
        $(this.elms.shufflePopupModal).removeClass(this.classes.modalOpen);
        await this.handleForceBuildChallengesConfirm();
    }

    checkUnfinishedAbandonedChallenge() {
        const unfinishedAbandonedChallenge = this._unfinishedAbandonedChallenge;
        if (unfinishedAbandonedChallenge) {
            this._openedChallenge = {
                ...unfinishedAbandonedChallenge,
                is_unfinished_abandoned: true,
            };
            // this.populateChallengeDetail();

            $(this.elms.modal).addClass(
                `${this.classes.isActiveChallenge} ${this.classes.isSubmitting}`,
            );
            $(this.elms.submissionPoints).text(
                this._data.challenge_page.challenge_detail
                    .completing_abandon_reward,
            );
        }
    }

    handleStartFormingSentenceClick(e) {
        e.preventDefault();

        this._currentStep = 0;
        this.populateBuildOptions();

        $(this.elms.formSentenceModal).addClass(this.classes.modalOpen);
        this._scheduleRestartSelectThemeIntroAnimations();
    }

    handleBackToMainChallengeClick(e) {
        e.preventDefault();

        $(this.elms.formSentenceModal).removeClass(this.classes.modalOpen);

        this.resetFormSentenceBuildStateImmediate();

        const sel = this._data?.challenge_page?.challenge_selection;
        if (sel) {
            $(this.elms.challengePageTitle).text(sel.title ?? "");
            $(this.elms.challengePageSubtitle).html(sel.subtitle ?? "");
        }

        $(this.elms.challengePage).addClass(this.classes.hasNoActiveChallenge);
    }

    populateBuildOptions() {
        const step = this._sentenceSteps[this._currentStep];
        let options = this[`_${step}`];

        // if (step === "subthemes" && this._selectedBuild.theme != null) {
        //     const themeId = Number(this._selectedBuild.theme);
        //     options = (this._subthemes || []).filter(
        //         (s) => Number(s.theme_id) === themeId,
        //     );
        // }

        $(this.elms.challengeBuildOptions).empty();

        let optionListHTML = "";
        // if (step === "subthemes" && options.length === 0) {
        //     optionListHTML =
        //         '<p class="challenge__build__empty-subthemes" role="status">No subthemes are linked to this theme yet. Use Reset to pick another theme.</p>';
        // } else {
        (options || []).forEach((option) => {
            optionListHTML += `<button class="challenge__build__option js-select-build-option" data-term-id="${option.term_id}">
                                <span>${option.name}</span>
                            </button>`;
        });
        // }
        $(this.elms.challengeBuildOptions).append(optionListHTML);
    }

    applyBuildChallengesSuccess(themeId, difficultyId, data) {
        if (Array.isArray(data) ? data.length > 0 : !!data) {
            this._challenges = data.challenges ?? [];
            this._challengeIds = this._challenges.map((challenge) => challenge.id);
            this.populateChallenges();

            const { challenge_selection } = this._data.challenge_page;
            const getName = (list, id) => {
                const item = list.find((i) => Number(i.term_id) === Number(id));
                return item && item.name ? item.name.toLowerCase() : "";
            };
            const replacements = {
                "{theme}": `<b>${getName(this._themes, themeId)}</b>`,
                "{subtheme}": "",
                // "{subtheme}": `<b>${getName(this._subthemes, subthemeId)}</b>`,
                "{difficulty}": `<b>${getName(this._difficulties, difficultyId)}</b>`,
            };

            const listTitle = challenge_selection.list_title;
            const listSubtitle = (
                challenge_selection.list_subtitle || ""
            ).replace(
                /\{theme\}|\{subtheme\}|\{difficulty\}/g,

                (key) => replacements[key] || "",
            );

            $(this.elms.challengePageTitle).text(listTitle);
            $(this.elms.challengePageSubtitle).html(listSubtitle);

            $(this.elms.challengePage)
                .removeClass(this.classes.hasNoActiveChallenge)
                .removeClass(this.classes.isCampaign);
            $(this.elms.formSentenceModal).removeClass(this.classes.modalOpen);
        }
    }

    async handleForceBuildChallengesConfirm() {
        const themeId = this._selectedBuild.theme;
        const difficultyId = this._selectedBuild.difficulty;

        if (!themeId || !difficultyId) {
            alert("Please select theme and difficulty.");
            return;
        }

        const previous_challenge_ids = (this._challenges || [])
            .map((c) => c.id)
            .filter((id) => id != null && id !== "");

        const [res] = await bdjs.goAsync(
            bdapi.post("game/force-build-challenges", {
                theme: themeId,
                difficulty: difficultyId,
                team_id: this._teamId,
                previous_challenge_ids,
            }),
        );

        if (res?.data?.success === true) {
            this.applyBuildChallengesSuccess(
                themeId,
                difficultyId,
                res.data.data,
            );
        } else if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
        }
    }

    async handleFinishChallengeBuild(e) {
        if (e) {
            e.preventDefault();
        }

        const themeId = this._selectedBuild.theme;
        const difficultyId = this._selectedBuild.difficulty;

        if (!themeId || !difficultyId) {
            alert("Please select theme and difficulty.");
            return;
        }

        const [res] = await bdjs.goAsync(
            bdapi.post("game/build-challenges", {
                theme: themeId,
                difficulty: difficultyId,
                team_id: this._teamId,
            }),
        );

        if (res?.data?.success === true) {
            this.applyBuildChallengesSuccess(
                themeId,
                difficultyId,
                res.data.data,
            );
        } else if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
        }
    }

    async handleSelectCampaignClick(e) {
        e.preventDefault();

        const campaign =
            this._data?.challenge_page?.challenge_selection?.campaign;
        if (!campaign?.active || !campaign.term_id) {
            return;
        }

        const [res] = await bdjs.goAsync(
            bdapi.post("game/build-campaign-challenges", {
                campaign: campaign.term_id,
                team_id: this._teamId,
            }),
        );

        if (res?.data?.success === true) {
            const data = res.data.data;
            if (data && typeof data === "object") {
                this._challenges = data.challenges ?? [];
                this.populateChallenges();

                const { challenge_selection } = this._data.challenge_page;
                const campaignName =
                    typeof campaign.name === "string" && campaign.name
                        ? campaign.name
                        : "";
                const esc = (s) =>
                    String(s)
                        .replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/"/g, "&quot;");
                const campaignHtml = campaignName
                    ? `<b>${esc(campaignName.toLowerCase())}</b>`
                    : "";
                const listTitle = challenge_selection.list_title;
                const listSubtitle = (
                    challenge_selection.list_subtitle || ""
                ).replace(/\{theme\}|\{subtheme\}|\{difficulty\}/g, (key) => {
                    if (key === "{theme}") {
                        return campaignHtml;
                    }
                    return "";
                });

                $(this.elms.challengePageTitle).text(listTitle);
                $(this.elms.challengePageSubtitle).html(listSubtitle);

                $(this.elms.challengePage)
                    .removeClass(this.classes.hasNoActiveChallenge)
                    .addClass(this.classes.isCampaign);
                $(this.elms.formSentenceModal).removeClass(
                    this.classes.modalOpen,
                );
            }
        } else if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
        }
    }

    async getActiveChallenge() {
        const [res] = await bdjs.goAsync(
            bdapi.post("game/get-active-challenge", {
                team_id: this._teamId,
            }),
        );

        if (res?.data?.success === true) {
            const data = res.data.data;
            if (Array.isArray(data) ? data.length > 0 : !!data) {
                this._openedChallenge = data;
            }
        } else if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
        }
    }
}
